import React, { useEffect } from 'react';
import AppLayout from './AppLayout';
import { App } from '../navigation';
import PublicLayout from './PublicLayout';
import { ROUTES } from '../constants/routes';
import { useLocation, useNavigate } from 'react-router-dom';
import { PublicApp } from '../navigation/publicApp';
import '../styles/common.scss';
import '../styles/panel.scss';

// Define your public routes here
const PUBLIC_ROUTES = new Set([ROUTES.login, ROUTES.register]);

const LayoutSelector = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const isPublic = PUBLIC_ROUTES.has(location.pathname);
    const authenticated = sessionStorage.getItem('authState') === 'authenticated';

    useEffect(() => {
        if (!authenticated && location.pathname !== ROUTES.register && location.pathname !== ROUTES.migrationDetails) {
            navigate(ROUTES.login);
        }
    }, [authenticated]);

    if (isPublic || !authenticated) {
        return (
            <PublicLayout>
                <PublicApp />
            </PublicLayout>
        );
    }
    return (
        <AppLayout>
            <App />
        </AppLayout>
    );
};

export default LayoutSelector;
